import { gql } from '@apollo/client';
import { SendTimeOptimizationInsights } from '../types';

export interface STOReportingQueryResponse {
  sendTimeOptimizationInsights: SendTimeOptimizationInsights;
}

export const fetchSTOReporting = gql`
query getSendTimeReporting($startDate: String!, $endDate: String!) {
  optimizeSendTimeReporting(startDate: $startDate, endDate: $endDate) {
    startDate
    endDate
    userLocalTimeAnalytics {
      overallEngagement {
        control {
          clickRate
          openRate
          unsubscribeRate
        }
        treatment {
          clickRate
          openRate
          unsubscribeRate
        }
        lift {
          clickRateLift
          openRateLift
          unsubscribeRateLift
        }
      }
      weeklyDistribution {
        weekStartDate
        weekday {
          key
          value
        }
        weekend {
          key
          value
        }
      }
      mostPreferredSendWindow
      leastPreferredSendWindow
      channelData {
        key
        value {
          stoEnabledPercentage
          optimizedUsersCount
          percentOfUsersWithOptimizedSend
          totalOptimizedSends
          sendsByDayAndTime {
            monday {
              morning
              afternoon
              evening
              night
            }
            tuesday {
              morning
              afternoon
              evening
              night
            }
            wednesday {
              morning
              afternoon
              evening
              night
            }
            thursday {
              morning
              afternoon
              evening
              night
            }
            friday {
              morning
              afternoon
              evening
              night
            }
            saturday {
              morning
              afternoon
              evening
              night
            }
            sunday {
              morning
              afternoon
              evening
              night
            }
          }
          topSendWindows
          engagementMetrics {
            control {
              clickRate
              openRate
              unsubscribeRate
            }
            treatment {
              clickRate
              openRate
              unsubscribeRate
            }
            lift {
              clickRateLift
              openRateLift
              unsubscribeRateLift
            }
          }
          deliveryMetrics {
            control {
              bounceRate
              deliveryRate
              sendSkipRate
              sendSkips
              bounces
            }
            treatment {
              bounceRate
              deliveryRate
              sendSkipRate
              sendSkips
              bounces
            }
            sendSkips {
              userPreference
              quietHours
              frequencyOptimize
              technicalError
            }
          }
          topPerformingCampaigns {
            campaignId
            campaignName
            engagement {
              control {
                clickRate
                openRate
                unsubscribeRate
              }
              treatment {
                clickRate
                openRate
                unsubscribeRate
              }
              lift {
                clickRateLift
                openRateLift
                unsubscribeRateLift
              }
            }
            totalSends
            percentageSendsStoEnabled
          }
        }
      }
    }
    projectTimeAnalytics {
      overallEngagement {
        control {
          clickRate
          openRate
          unsubscribeRate
        }
        treatment {
          clickRate
          openRate
          unsubscribeRate
        }
        lift {
          clickRateLift
          openRateLift
          unsubscribeRateLift
        }
      }
      weeklyDistribution {
        weekStartDate
        weekday {
          key
          value
        }
        weekend {
          key
          value
        }
      }
      mostPreferredSendWindow
      leastPreferredSendWindow
      channelData {
        key
        value {
          stoEnabledPercentage
          optimizedUsersCount
          percentOfUsersWithOptimizedSend
          totalOptimizedSends
          sendsByDayAndTime {
            monday {
              morning
              afternoon
              evening
              night
            }
            tuesday {
              morning
              afternoon
              evening
              night
            }
            wednesday {
              morning
              afternoon
              evening
              night
            }
            thursday {
              morning
              afternoon
              evening
              night
            }
            friday {
              morning
              afternoon
              evening
              night
            }
            saturday {
              morning
              afternoon
              evening
              night
            }
            sunday {
              morning
              afternoon
              evening
              night
            }
          }
          topSendWindows
          engagementMetrics {
            control {
              clickRate
              openRate
              unsubscribeRate
            }
            treatment {
              clickRate
              openRate
              unsubscribeRate
            }
            lift {
              clickRateLift
              openRateLift
              unsubscribeRateLift
            }
          }
          deliveryMetrics {
            control {
              bounceRate
              deliveryRate
              sendSkipRate
              sendSkips
              bounces
            }
            treatment {
              bounceRate
              deliveryRate
              sendSkipRate
              sendSkips
              bounces
            }
            sendSkips {
              userPreference
              quietHours
              frequencyOptimize
              technicalError
            }
          }
          topPerformingCampaigns {
            campaignId
            campaignName
            engagement {
              control {
                clickRate
                openRate
                unsubscribeRate
              }
              treatment {
                clickRate
                openRate
                unsubscribeRate
              }
              lift {
                clickRateLift
                openRateLift
                unsubscribeRateLift
              }
            }
            totalSends
            percentageSendsStoEnabled
          }
        }
      }
    }
  }
}
`;
